import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

const useAppDispatch = () =>
  useDispatch<ThunkDispatch<STATES.AppState, null, Action>>();

export { useAppDispatch };
